import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'number'})
export class NumberPipe implements PipeTransform {
  transform(value): number {
    let exp;
    if (isNaN(value)) {
      exp = value;
    } else {
      exp = value.toString();
    }
    exp = exp.replace('.', ',');

    const splitExp = exp.split(',');

    exp = splitExp[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    if (splitExp.length === 2) {
      exp = exp + ',' + splitExp[1];
    }

    return exp;
  }
}



// WEBPACK FOOTER //
// ./src/app/number.pipe.ts